import { General } from "@/utils/constants";

export function isDocumentType(type: string) {
  const documentTypeList = [
    General.SUBSCRIPTION_REQUEST,
    General.REFUSED_SUBSCRIPTION,
    General.TEXTS.SIGNED_DOCUMENT,
    General.TEXTS.KNOWLEDGE_GIVEN,
    General.TEXTS.SIGNATURE_CANCELED
  ];
  return documentTypeList.includes(type);
}
